import React, { useState, useContext, useRef, useEffect } from "react";
import Map from "../Map/map";
import DataTable from "../DataTable/datatable";
import Newsfeed from "../NewsList/newslist";
import CompanyTabs from "../CompanyDetailsTabs/companydetails";
import FilterBar from "../FilterBar/filterbar";
import Header from "../Header/header";
import ChatBot from "../ChatBot/chatbot";
import SiteTabs from "../SiteDetailsTabs/sitedetails";
import BuildingFilterbar from "../BuildingFilterBar/buildingfilterbar";
import BuildingTable from "../BuildingTable/buildingtable";
import BuildingOwnerTabs from "../BuildingOwnerInfoTabs/buildingownerdetails";
import BuildingInfo from "../BuildingInfo/buildinginfo";
import { useLocation } from "react-router-dom";
import PlantMap from "../ProjectPlantMap/project_plant_map"
import Plantdetails from "../PlantsDetails/plantsdetails"
import ProjectDetails from "../ProjectDetails/projectdetails"
import Spinner from "../Spinner/spinner.js";

import "./datapage.css";
import { RegisterIdContext } from "../../hooks/RegisterIdContext";


const DataPage = () => {
  //const { registerId,markerLoc, groupName, showFilterBar, bldOwner, bldMasterId } = useContext(RegisterIdContext);
  const { registerId } = useContext(RegisterIdContext);
  const { markerLoc } = useContext(RegisterIdContext);
  const { showFilterBar, refineSearchActive, isFacilitiesEmpty } = useContext(RegisterIdContext);
  const { groupName, bldOwner, bldMasterId, projectId } = useContext(RegisterIdContext);


  let [markers, setMarkers] = useState([]);
  const bldtableRef = useRef();
  const location = useLocation();
  const [filterState, setFilterState] = useState(location.state);

  useEffect(() => {
    if (showFilterBar === false || (!registerId && registerId?.length === 0)) {
      setFilterState(null);
    }

  }, [showFilterBar, registerId]);
  // Function to update markers and state-level lat/lng
  const updateMapMarkers = (newMarkers) => {
    setMarkers([...newMarkers]); // Update markers
  };

  //Plant cordinates 
  const [plantCoordinates, setPlantCoordinates] = useState([]);
  const [projectCoordinates, setProjectCoordinates] = useState([]);

  // // Run timeout once when component initializes
  // const [loading, setLoading] = useState(true);
  // const [activeCondition, setActiveCondition] = useState(null);

  // // figure out which condition is true and set the loader till the data comes
  // let currentCondition = null;
  // if (registerId?.length > 0 && markerLoc && showFilterBar) {
  //   currentCondition = "siteTabs1";
  // } else if (
  //   registerId?.length > 0 &&
  //   !isFacilitiesEmpty &&
  //   markerLoc == null &&
  //   !showFilterBar
  // ) {
  //   currentCondition = "siteTabs2";
  // } else if (isFacilitiesEmpty) {
  //   currentCondition = "plantDetails";
  // } else if (groupName) {
  //   currentCondition = "companyTabs";
  // } else if (bldMasterId) {
  //   currentCondition = "buildingInfo";
  // } else if (bldOwner) {
  //   currentCondition = "buildingOwner";
  // } else if (projectId) {
  //   currentCondition = "projectDetails";
  // } else if (!filterState) {
  //   currentCondition = "newsFeed";
  // }

  // // 🔄 when condition changes → reset loader
  // if (currentCondition && currentCondition !== activeCondition) {
  //   setActiveCondition(currentCondition);
  //   setLoading(true);
  //   setTimeout(() => setLoading(false), 600);
  // }

  return (
    <div className="databody">
      <div className="">
        <div className="row mt-2">
          {showFilterBar ? (
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
              <FilterBar updateMapMarkers={updateMapMarkers} filterState={filterState} plantCoordinates={plantCoordinates} projectCoordinates={projectCoordinates} />
            </div>
          ) : (
            <div className="col-xl-12 col-lg-12 col-md-12 col-12">
              <BuildingFilterbar updateMapMarkers={updateMapMarkers} tableRef={bldtableRef} />
            </div>
          )}
        </div>
      </div>

      {/* Single Full-height Row */}
      <div className="row mt-2">
        {/* Left Side (Map + Table) */}
        <div className="col-xl-8 col-lg-8 col-md-8 col-8">
          <div className="map-container">
            {!refineSearchActive ? <Map markers={markers} /> : <PlantMap plantCoordinates={plantCoordinates} projectCoordinates={projectCoordinates} />}

          </div>
          <div className="table-container overflow-auto mt-1">
            {showFilterBar ? <DataTable setPlantCoordinates={setPlantCoordinates} setProjectCoordinates={setProjectCoordinates} /> : <BuildingTable ref={bldtableRef} />}
          </div>
        </div>

        {/* Right Side (Company Details) */}
        <div className="col-xl-4 col-lg-4 col-md-4 col-4">

          <div className="company-details-container">
            {registerId?.length > 0 && markerLoc && showFilterBar ? (
              <SiteTabs data={{ registerId }} />
            ) : registerId?.length > 0 && !isFacilitiesEmpty && markerLoc == null && showFilterBar ? (
              <SiteTabs data={{ registerId }} />
            ) : isFacilitiesEmpty ? (
              <Plantdetails />
            ) : groupName ? (
              <CompanyTabs />
            ) : bldMasterId ? (
              <BuildingInfo />
            ) : bldOwner ? (
              <BuildingOwnerTabs />
            ) : projectId ? (
              <ProjectDetails />
            ) : !filterState ? (
              <Newsfeed />
            ) : null}
          </div>

          <div><ChatBot /></div>
        </div>

      </div>
    </div>
  );
};

export default DataPage;
